<form class="flex flex-col gap-4" [formGroup]="formGroup">
  <mat-form-field class="flex grow" subscriptSizing="dynamic">
    <mat-label>Label</mat-label>
    <input
      matInput
      type="text"
      formControlName="label"
      maxlength="50"
      [disabled]="disabled()"
    />
    <mat-hint align="end">
      Leave blank to use the default recall name.
    </mat-hint>
  </mat-form-field>

  <mat-form-field class="flex grow" subscriptSizing="dynamic">
    <mat-label>Recall Period</mat-label>
    <input
      matInput
      type="number"
      formControlName="periodInMonths"
      [disabled]="disabled()"
    />
    <span matTextSuffix>months</span>
  </mat-form-field>

  <mat-form-field class="flex grow" subscriptSizing="dynamic">
    <mat-label>Recall Treatments</mat-label>
    <mat-select
      matInput
      formControlName="treatmentRefs"
      [compareWith]="recallTreatmentOptions.compareWithFn"
      [multiple]="true"
      [disabled]="disabled()"
    >
      <mat-option>
        <ngx-mat-select-search
          placeholderLabel="Search for treatments"
          noEntriesFoundLabel="No matching treatments found"
          [formControl]="recallTreatmentOptions.searchCtrl"
        />
      </mat-option>

      @for (
        option of recallTreatmentOptions.filteredTreatments();
        track option.group
      ) {
        @if (option.items.length > 0) {
          <mat-optgroup [label]="option.group">
            @for (treatment of option.items; track treatment.ref.path) {
              <mat-option [value]="treatment.ref">{{
                treatment.name
              }}</mat-option>
            }
          </mat-optgroup>
        }
      }
    </mat-select>
  </mat-form-field>

  @if (showOverlapWarning()) {
    <pr-information-box theme="warn">
      <span>
        These treatments are also part of the {{ otherTrackLabel() }}.
        Appointments using them will update both recall tracks.
      </span>
      @if (overlapTreatmentNames().length > 0) {
        <ul class="!m-0 mt-1 list-disc pl-6">
          @for (name of overlapTreatmentNames(); track name) {
            <li>{{ name }}</li>
          }
        </ul>
      }
    </pr-information-box>
  }
</form>
